import { render } from "./TransferenciaContasVisualizacaoModal.vue?vue&type=template&id=a63eaa86&scoped=true&ts=true"
import script from "./TransferenciaContasVisualizacaoModal.vue?vue&type=script&lang=ts"
export * from "./TransferenciaContasVisualizacaoModal.vue?vue&type=script&lang=ts"

import "./TransferenciaContasVisualizacaoModal.vue?vue&type=style&index=0&id=a63eaa86&scoped=true&lang=css"

import exportComponent from "D:\\Desenvolvimento\\NeoXApp\\NeoX.Frontend\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a63eaa86"]])

export default __exports__